"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var payment_select_routes_1 = require("./payment-select.routes");
var router_1 = require("@angular/router");
var common_1 = require("@angular/common");
var form_module_1 = require("../form/form.module");
var core_1 = require("@ngx-translate/core");
var common_module_1 = require("../common/common.module");
var core_2 = require("@angular/core");
var payment_select_component_1 = require("./components/payment-select.component");
var PaymentSelectModule = (function () {
    function PaymentSelectModule() {
    }
    return PaymentSelectModule;
}());
PaymentSelectModule = __decorate([
    core_2.NgModule({
        imports: [
            core_1.TranslateModule,
            form_module_1.TRTFormModule,
            common_1.CommonModule,
            common_module_1.TRTCommonModule,
            router_1.RouterModule,
            payment_select_routes_1.PaymentSelectRoutingModule
        ],
        exports: [payment_select_component_1.PaymentSelectComponent],
        declarations: [payment_select_component_1.PaymentSelectComponent],
        providers: [],
    })
], PaymentSelectModule);
exports.PaymentSelectModule = PaymentSelectModule;
var PCPaymentSelectModule = (function () {
    function PCPaymentSelectModule() {
    }
    return PCPaymentSelectModule;
}());
PCPaymentSelectModule = __decorate([
    core_2.NgModule({
        imports: [
            core_1.TranslateModule,
            form_module_1.TRTFormModule,
            common_1.CommonModule,
            common_module_1.TRTCommonModule,
            router_1.RouterModule,
            payment_select_routes_1.PCPaymentSelectRoutingModule
        ],
        exports: [payment_select_component_1.PCPaymentSelectComponent],
        declarations: [payment_select_component_1.PCPaymentSelectComponent],
        providers: [],
    })
], PCPaymentSelectModule);
exports.PCPaymentSelectModule = PCPaymentSelectModule;
